import React from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

const LandingNavbar = () => {
    const { t } = useTranslation();

    return (
        <Navbar bg="light" expand="lg" className="shadow-sm">
            <Container>
                <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
                    <img src="/logo_evazard_transparente.svg" alt="Evazard Logo" height="40" className="d-inline-block align-top me-2" />
                    <span className="fw-bold text-primary">Evazard</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto d-flex align-items-center">
                        <Nav.Link as={Link} to="/">{t('landingPage.navbar.home')}</Nav.Link>
                        <Nav.Link href="#features">{t('landingPage.navbar.features')}</Nav.Link>
                        <Nav.Link href="#pricing">{t('landingPage.navbar.pricing')}</Nav.Link>
                        <Nav.Link href="#contact">{t('landingPage.navbar.contact')}</Nav.Link>
                        <Link to="/login">
                            <Button variant="outline-primary" className="ms-3 me-2">
                                {t('landingPage.navbar.login')}
                            </Button>
                        </Link>
                        <Link to="/register">
                            <Button variant="primary">
                                {t('landingPage.navbar.register')}
                            </Button>
                        </Link>
                        <div className="ms-3">
                            <LanguageSelector />
                        </div>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default LandingNavbar;
